import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Button } from 'semantic-ui-react'
import TitDer from '../../../components/funcionales/titder';
import { List } from 'semantic-ui-react'

import SeguroPermite from '../../../components/funcionales/seguropermite'

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'
var moment = require('moment');

const DetallePl = ({elemento, indice, handleChange}) => {
  let numHoras= 0
  if(elemento.minutosTotalTurno && elemento.minutosTotalTurno>0){
    numHoras=parseFloat(elemento.minutosTotalTurno/60).toFixed(1)
  }

  return(
    <tr className=''>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.nombreUsuario}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cedula}</td>   
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.estado}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaHoraIniTurno.substr(0, 19)}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.latitudIni}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.longitudIni}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.observacionesIni}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaHoraFinTurno?elemento.fechaHoraFinTurno.substr(0, 19):''}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.latitudFin}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.longitudFin}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{new Intl.NumberFormat('de-DE').format(numHoras)}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.observacionesFin}</td>
    </tr>
  )
};
const ListaPl = ({list, handleChange}) => {
    const nivel1Detalle = list.map((elemento, i) => <DetallePl elemento={elemento} key={i} indice={i}
      handleChange={handleChange}/>);
    return(
      <tbody className=''>
        {nivel1Detalle}
      </tbody>
    )
  };

class GerSegTur2 extends React.Component {
  state={list: this.props.allTurnoRtes.allTurnoRtes?this.props.allTurnoRtes.allTurnoRtes:[],
    argsDocum: {desde: this.props.fechaHoy, hasta: this.props.fechaFin},
    permiteUpdate: true, confirmaAct: false, open: false, argsBuscCoti: {}, ingresa: 'S',
    argsQuery: `{$project: { 
        cedula: 1, nombreUsuario: 1, minutosTotalTurno: 1, estado: 1, fechaHoraIniTurno: 1, fechaHoraFinTurno: 1, 
        latitudIni: 1, longitudIni: 1, ubicacionIni: 1, latitudFin: 1, longitudFin: 1, observacionesIni: 1, observacionesFin: 1
      }}
    `
  }


  handleChange = async (ev, indice) => {

    if(ev.target.name==="desde"||ev.target.name==="hasta"){
      const argsDocum = this.state.argsDocum
      argsDocum[ev.target.name] = ev.target.value
      let argsBuscar=`'estado': {$ne: 'XXX'}`
      if(ev.target.name==="desde"){
        argsBuscar += `, fechaHoraIniTurno: { $gte: new Date('${ev.target.value}')}`
      }else{
        argsBuscar += `, fechaHoraIniTurno: { $gte: new Date('${argsDocum.desde}')}`
      }
      if(this.props.argsBuscTur.nombreUsuario){
        argsBuscar += `, 'nombreUsuario': /${this.props.argsBuscTur.nombreUsuario}/i`
      }      
      if(this.props.argsBuscTur.estado){
        argsBuscar += `, 'estado': /${this.props.argsBuscTur.estado}/i`
      }
      let argsBuscar2=""
      if(ev.target.name==="desde"){
        argsBuscar2 = `fechaHoraIniTurno: { $lte: new Date('${argsDocum.hasta}') }`
      }else{
        argsBuscar2 = `fechaHoraIniTurno: { $lte: new Date('${ev.target.value}') }`
      }
      
      let argsBuscarPl = {tipoqry: `[{$match: {${argsBuscar}}}, ${this.state.argsQuery}, 
        {$match: {${argsBuscar2}}}, 
        {$sort: {fechaHoraIniTurno: -1}}]`}

      await this.props.allTurnoRtes.refetch(argsBuscarPl)
      if(this.props.allTurnoRtes.allTurnoRtes){
        this.setState({list: 
          this.props.allTurnoRtes.allTurnoRtes?this.props.allTurnoRtes.allTurnoRtes:[]
        })
      }
      this.setState({argsDocum});
    }
  }

  handleGenExc = async (ev, list)=>{
    if(list.length>0){
      document.body.style.cursor = 'wait'
      //Archivo Excel
      let xlsString = []
      let xlsString1 = []
      xlsString1 = ['USUARIO', 'CEDULA', 'ESTADO', 'INICIO TURNO', 'LATITUD INICIO', 'LONGITUD INICIO', 'OBSERVACIONES INICIO DE TURNO', 'FIN TURNO', 'LATITUD FIN', 'LONGITUD FIN', 'HORAS TURNO', 'OBSERVACIONES FIN DE TURNO']
      xlsString.push(xlsString1)

      for (let iiii=0;iiii<list.length;iiii++){
        let numHoras= 0
        if(list[iiii].minutosTotalTurno && list[iiii].minutosTotalTurno>0){
          numHoras=parseFloat(list[iiii].minutosTotalTurno/60).toFixed(1)
        }

        xlsString1 = [list[iiii].nombreUsuario, list[iiii].cedula, list[iiii].estado, list[iiii].fechaHoraIniTurno, 
            list[iiii].latitudIni, list[iiii].longitudIni, list[iiii].observacionesIni?list[iiii].observacionesIni:'', 
            list[iiii].fechaHoraFinTurno?list[iiii].fechaHoraFinTurno:'', list[iiii].latitudFin?list[iiii].latitudFin:'', 
            list[iiii].longitudFin?list[iiii].longitudFin:'', new Intl.NumberFormat('de-DE').format(numHoras), list[iiii].observacionesFin?list[iiii].observacionesFin:'']
        xlsString.push(xlsString1)

        if(iiii===list.length-1){
          var wb = XLSX.utils.book_new();

          wb.Props = {
            Title: "SheetJS Tutorial",
            Subject: "Test",
            Author: "Red Stapler",
            CreatedDate: new Date(2017,12,19)
          };

          wb.SheetNames.push("Turnos");

          let ws_data = xlsString;

          let ws = XLSX.utils.aoa_to_sheet(ws_data);
          wb.Sheets["Turnos"] = ws;
          let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
          function s2ab(s) { 
            let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
            let view = new Uint8Array(buf);  //create uint8array as viewer
            for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
            return buf;    
          }
          saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'Turnos.xlsx');
//FIN Exportar a XLS
        }

        document.body.style.cursor = 'default'

        this.setState({open: false, confirmaAct: false})
      }
    }
  }
  

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){
      this.setState({open: true})
    }else{
      this.setState({open: false})
    };
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  async componentDidUpdate(prevProps){
    if(((this.props.argsBuscTur || prevProps.argsBuscTur) && this.props.argsBuscTur!==prevProps.argsBuscTur) || this.state.ingresa==='S'){
      let argsBuscar=`'fechaHoraIniTurno': { $gte: new Date('${this.state.argsDocum.desde}')}`
      if(this.props.argsBuscTur.nombreUsuario){
        argsBuscar += `, 'nombreUsuario': /${this.props.argsBuscTur.nombreUsuario}/i`
      }    
      if(this.props.argsBuscTur.estado){
        argsBuscar += `, 'estado': /${this.props.argsBuscTur.estado}/i`
      }
      let argsBuscar2=`fechaHoraIniTurno: { $lte: new Date('${this.state.argsDocum.hasta}') }`
      
      let argsBuscarPl = {tipoqry: `[{$match: {${argsBuscar}}}, ${this.state.argsQuery}, 
        {$match: {${argsBuscar2}}},
        {$sort: {fechaHoraIniTurno: -1}}
      ]`}

      await this.props.allTurnoRtes.refetch(argsBuscarPl)
      if(this.props.allTurnoRtes.allTurnoRtes){
        this.setState({list: 
          this.props.allTurnoRtes.allTurnoRtes?this.props.allTurnoRtes.allTurnoRtes:[]
        })
      }
      this.setState({ingresa: 'N'}) 
    }
  }

  render(){
    const {list, argsDocum, checkSeleccInfAll, permiteUpdate, confirmaAct, open} = this.state;

    let mensaje = "Generar Excel de informe"
    let imgIcon = "images/documento_32.png"

return (
  <div>
    <List selection>
      <TitDer list={list} textBoton1="Seguimiento a turnos" btnNuevo={"NO"} styles={this.props.styles} handleClick={this.props.handleClick} />
        <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, list, argsDocum):()=>{}}>
            <div className="ui three column stackable grid">
              {/* <div className="row container"> */}
                <div className="column" style={{width: '15%'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.0em 0em 0em 0em'}}>
                    Desde
                  </p>
                  <Form.Field>
                    <input style={this.props.styles.input} type='date' name="desde" id="desde" value={argsDocum.desde} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '15%'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.0em 0em 0em 0em'}}>
                  Hasta
                  </p>
                  <Form.Field>
                    <input style={this.props.styles.input} type='date' name="hasta" id="hasta" value={argsDocum.hasta} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                {/* {localStorage.getItem('userLogin')==="slcm@slcm.com" && */}
                  <div className="column" style={{width: '18%', paddingTop: '0.0em'}}>
                    <br></br>
                    <br></br>
                    <Button id="excel" name="excel" style={this.props.styles.confirmar} onClick={(ev)=>this.handleGenExc(ev, list)} fluid>
                      Exportar a excel
                    </Button>
                  </div>
                {/* }  */}
              {/* </div> */}
            </div>
            {/* <br></br> */}
            <div>
              <div style={{height: '45em', overflow: 'auto'}}>
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Usuario</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cedula</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Estado</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Inicio de turno</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Latitud inicio</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Longitud inicio</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Observaciones de inicio</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Fin de turno</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Latitud fin</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Longitud fin</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Horas de turno</th>
                      <th className='' position = 'sticky' top = '0' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Observaciones fin de turno</th>
                     </tr>
                  </thead>
                  <ListaPl list={list} handleChange={this.handleChange}/>
                </table>
                <p></p>
              </div>
            </div>
          </Form>
        </div>
      </List>
    </div>
    )
  }
};

export default compose(
  graphql(queries.query.allTurnoRtes, {name:'allTurnoRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {estado: {$ne: 'XXX'}}}]`}}}}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(GerSegTur2)
